import { render, staticRenderFns } from "./ServiceElder.vue?vue&type=template&id=0c4e5b45&scoped=true&"
import script from "./ServiceElder.vue?vue&type=script&lang=js&"
export * from "./ServiceElder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4e5b45",
  null
  
)

export default component.exports